import { c as _c } from "react/compiler-runtime";
import { Box, Grid, Skeleton } from '@mui/material';
export function DesktopSkeleton(t0) {
  const $ = _c(16);
  const {
    isSpotlight
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      xs: "none",
      md: "flex"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== isSpotlight) {
    t2 = isSpotlight && <Grid size={12} display="flex" alignItems="center" mb={3}><Skeleton variant="rounded" width="100%" height={130} /></Grid>;
    $[1] = isSpotlight;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Grid size={12} display="flex" alignItems="center" pb={4}><Skeleton variant="rounded" width={250} height={40} /></Grid>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Box><Skeleton variant="rounded" width={200} height={105} /></Box>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Box flex={1} display="flex" flexDirection="column" gap={2}><Skeleton variant="rounded" width={350} height={30} /><Skeleton variant="rounded" width={250} height={25} /><Skeleton variant="rounded" width={125} height={27.5} /></Box>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Grid size={12} display="flex" alignItems="center" pb={3} gap={4}>{t4}{t5}<Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" gap={2}><Skeleton variant="rounded" width={250} height={50} sx={{
          mb: 1
        }} /><Skeleton variant="rounded" width={150} height={20} /></Box></Grid>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Grid size={12} display="flex" justifyContent="space-between" alignItems="center" pb={3}>{[...Array(4)].map(_temp)}</Grid>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Grid size={12} display="flex" justifyContent="space-between" alignItems="center" pb={4}>{[...Array(4)].map(_temp2)}</Grid>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t2) {
    t9 = <Grid container={true} px={3.5} pt={3.5} pb="0.75rem">{t2}{t3}{t6}{t7}{t8}</Grid>;
    $[9] = t2;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Grid size={12} display="flex" borderTop="1px solid #d8d9da" py="calc(0.5rem + 12px)"><Skeleton variant="rounded" width={30} height={27} sx={{
        ml: 3.5,
        mr: 2
      }} /><Skeleton variant="rounded" width={250} height={27} /></Grid>;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Grid size={12} display="flex" borderTop="1px solid #d8d9da" py="calc(0.5rem + 12px)"><Skeleton variant="rounded" width={30} height={27} sx={{
        ml: 3.5,
        mr: 2
      }} /><Skeleton variant="rounded" width={250} height={27} /></Grid>;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Grid size={12} display="flex" borderTop="1px solid #d8d9da" py="calc(0.5rem + 12px)"><Skeleton variant="rounded" width={30} height={27} sx={{
        ml: 3.5,
        mr: 2
      }} /><Skeleton variant="rounded" width={250} height={27} /></Grid>;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] !== t9) {
    t13 = <Grid border="1px solid #d8d9da" mb={3.5} borderRadius="8px" container={true} position="relative" display={t1}>{t9}{t10}{t11}{t12}</Grid>;
    $[14] = t9;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  return t13;
}
function _temp2(__0, idx_0) {
  return <Grid key={idx_0} size={3} px={2}><Skeleton variant="rounded" width="100%" height={75} /></Grid>;
}
function _temp(_, idx) {
  return <Grid key={idx} size={3} px={2}><Skeleton variant="rounded" width="100%" height={75} /></Grid>;
}